import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';
import { Companies } from 'src/app/core/resources/companies';

@Injectable({
  providedIn: 'root'
})
export class CargoSearchAccessService {
  public permission = Permission;

  constructor(
    private authService: AuthService,
    private permissionRole: PermissionRole,
  ) { }

  private get isJLRBCompany(): boolean {
    return !!(this.authService && this.authService.getUserSession()
      && this.authService.getUserSession().clientCompanyId === Companies.companiesNIT.JL_RB);
  }

  private get hasServiceAccessPermission(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.searchCargo
    );
  }

  private get hasVehicleAccessPermission(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.administration.module,
      this.permission.administration.adminVehicles
    );
  }

  private get hasUserAccessPermission(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.administration.module,
      this.permission.administration.adminUsers
    );
  }

  private get hasTransportOrEscortServices(): boolean {
    return !!(this.authService && (this.authService.hasTransportServicesCompany || this.authService.hasEscortServicesCompany));
  }

  get showCargoSection(): boolean {
    return !this.isJLRBCompany && this.hasServiceAccessPermission;
  }

  get showManifestSection(): boolean {
    return this.showCargoSection
      && !!(this.authService && this.authService.hasTransportServicesCompany);
  }

  get showVehicleSection(): boolean {
    return this.hasTransportOrEscortServices && this.hasVehicleAccessPermission;
  }

  get showUserSection(): boolean {
    return this.hasTransportOrEscortServices && this.hasUserAccessPermission;
  }

  get showSearchShortcut(): boolean {
    return this.showCargoSection || this.showVehicleSection || this.showUserSection;
  }
}
